import { EMPTY_LIST } from '../../../constants/common'
import { MATCH_SCORE_RING_SIZE } from '../../RentalPortal'

const MATCH_CRITERIA = [
  {
    applicant_value: '2026-11-01',
    gates_eligibility: false,
    key: 'move_in',
    listing_value: '2026-10-15',
    reason: null,
    s: 0.9605,
    status: 'fits',
    weight: 30,
  },
  {
    applicant_value: 1450,
    gates_eligibility: true,
    key: 'budget',
    listing_value: 1290,
    reason: null,
    s: 0.62,
    status: 'partial',
    weight: 25,
  },
  {
    applicant_value: 5,
    gates_eligibility: true,
    key: 'household',
    listing_value: 3,
    reason: 'household_exceeds_max',
    s: 0,
    status: 'does_not_fit',
    weight: 20,
  },
  {
    applicant_value: null,
    gates_eligibility: false,
    key: 'needs',
    listing_value: ['balcony', 'lift'],
    reason: null,
    s: null,
    status: 'not_provided',
    weight: 15,
  },
  {
    applicant_value: null,
    gates_eligibility: false,
    key: 'lease_term',
    listing_value: null,
    reason: 'deferred_to_screening',
    s: null,
    status: 'not_applicable',
    weight: 5,
  },
]

const MATCH_WEIGHTS_USED = {
  normalised: {
    budget: 0.2632,
    household: 0.2105,
    lease_term: 0.0526,
    move_in: 0.3158,
    needs: 0.1579,
  },
  raw: {
    budget: 25,
    household: 20,
    lease_term: 5,
    move_in: 30,
    needs: 15,
  },
}

export const MATCH_LIBRARY_ELIGIBLE = {
  breakdown: [
    { key: 'move_in', s: 0.9605, w: 30, w_pct: 0.3158, ws: 28.815 },
    { key: 'budget', s: 0.62, w: 25, w_pct: 0.2632, ws: 15.5 },
    { key: 'household', s: 1, w: 20, w_pct: 0.2105, ws: 20 },
    { key: 'needs', s: 0.8, w: 15, w_pct: 0.1579, ws: 12 },
  ],
  coverage: 0.9,
  criteria: MATCH_CRITERIA,
  criteria_count: 7,
  eligibility: 'eligible',
  eligibility_reasons: EMPTY_LIST,
  provided_count: 5,
  score: 0.9868,
  score_reason: 'ok',
  weights_used: MATCH_WEIGHTS_USED,
}

export const MATCH_LIBRARY_INCOMPLETE = {
  coverage: null,
  criteria: MATCH_CRITERIA,
  criteria_count: 7,
  eligibility: 'incomplete',
  eligibility_reasons: ['missing_applicant_data'],
  provided_count: 2,
  score_reason: 'insufficient_coverage',
  weights_used: MATCH_WEIGHTS_USED,
}

export const MATCH_LIBRARY_NOT_ELIGIBLE = {
  coverage: null,
  criteria: MATCH_CRITERIA,
  criteria_count: 7,
  eligibility: 'not_eligible',
  eligibility_reasons: ['household_exceeds_max'],
  provided_count: 5,
  score_reason: 'not_eligible',
  weights_used: MATCH_WEIGHTS_USED,
}

export const MATCH_LIBRARY_RING_SAMPLES = [
  { coverage: 1, label: 'score 99 %, coverage 100 %', score: 0.9868 },
  { coverage: 0.9, label: 'score 74 %, coverage 90 %', score: 0.74 },
  { coverage: 0.55, label: 'score 41 %, coverage 55 %', score: 0.41 },
]

export const MATCH_LIBRARY_RING_SIZES = [
  MATCH_SCORE_RING_SIZE.table,
  MATCH_SCORE_RING_SIZE.tile,
  MATCH_SCORE_RING_SIZE.card,
]

export const MATCH_LIBRARY_PROVENANCES = [
  { at: '2026-10-20T09:30:00Z', source: 'applicant' },
  { at: '2026-10-21T14:05:00Z', source: 'manual' },
  { at: '2026-10-22T07:45:00Z', source: 'greta_message' },
]
